"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toTwoDigits = exports.MILLISECONDS = void 0;
exports.MILLISECONDS = {
    ONE_DAY: 86400000,
    ONE_HOUR: 3600000,
    ONE_MINUTE: 60000,
    ONE_SECOND: 1000,
};
var toTwoDigits = function (num) { return "0".concat(num).slice(-2); };
exports.toTwoDigits = toTwoDigits;
//# sourceMappingURL=date.js.map